import { newToolFilterOAuthMcp } from "../oauth.ts";

export const airtableMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.airtable.com/favicon.ico",
  url: "https://mcp.airtable.com/mcp",
  label: "Airtable",
});
